export const tag = (x) => x;
export function untag(x) {
    return x;
}
export function retag(x) {
    return tag(untag(x));
}
export function snakeToCamelCase(x, pascal = true) {
    if (x.length === 0) {
        return x;
    }
    let out = '';
    const parts = x.split('_');
    let i = 0;
    for (const part of parts) {
        if (part.length === 0) {
            continue;
        }
        if ((i === 0 && pascal) || i > 0) {
            out += part[0].toLocaleUpperCase() + part.slice(1);
        }
        i++;
    }
    return out;
}
//# sourceMappingURL=util.js.map